import * as React from 'react';

import { Typography, TypographyOwnProps } from '@mui/material';
import styled from '@emotion/styled';

const Fieldset = styled.fieldset`
  border-radius: 4px;
  width: 100%;
  padding: 4px 8px 4px 16px;
  font-size: 1rem;
  line-height: 1.4375em;
  min-height: 66px;
  margin-top: -10px;
`;

const Legend = styled.legend`
  font-size: 0.75em;
`;

interface IReadOnlyField {
  name?: string;
  value?: string;
  textProps?: TypographyOwnProps;
  legendProps?: React.CSSProperties;
}

function ReadOnlyField({ name, value, textProps, legendProps }: IReadOnlyField) {
  return (
    <Fieldset>
      <Legend style={legendProps}>{name}</Legend>
      <Typography sx={textProps} variant="body1">{value}</Typography>
    </Fieldset>
  );
}

export default ReadOnlyField;
